import type { GetStaticPathsResult, GetStaticPropsContext } from "next/types";
import { withPage } from "src/utils/pagination/with-page";
import { ProductListingView } from "src/organisms/ProductListingView";
import type {
  BrandProductList,
  ProductListProps,
} from "src/types/product-listing";
import { DEFAULT_PAGE_NOT_FOUND } from "src/utils/constants";
import {
  getBrandProductListProps,
  type BrandProductListReturnType,
} from "src/utils/search-provider/get-product-list-props";

type BrandPageProps = ProductListProps<BrandProductList>;

function BrandPage({
  pageProps,
}: {
  pageProps: BrandPageProps;
}): React.ReactElement {
  return <ProductListingView defaultSorting="POPULARITY" {...pageProps} />;
}

export function getStaticPaths(): GetStaticPathsResult {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export const getStaticProps = withPage(async function getStaticProps(
  {
    params,
  }: GetStaticPropsContext<{
    slug: string[];
  }>,
  page
): BrandProductListReturnType {
  if (!params || !params.slug || params.slug.length > 2) {
    return DEFAULT_PAGE_NOT_FOUND;
  }

  const [slug, gender] = params.slug;

  if (!slug) {
    return DEFAULT_PAGE_NOT_FOUND;
  }

  return getBrandProductListProps({
    gender,
    payload: {
      slug,
    },
    page,
  });
});

export default BrandPage;
